(() => {
  'use strict';

  if (window.BMMotion && window.BMMotion.__canonical === true) return;

  const selectors = [
    '.bm-help-hub [data-bm-reveal]',
    '.bm-info-page [data-bm-reveal]',
    '.bm-info-page .bm-rich-intro',
    '.bm-info-page .bm-rich-section',
    '.bm-info-page .bm-info-fact',
    '.bm-info-page .bm-info-page__related a',
    '.bm-knowledge [data-bm-reveal]',
    '.bm-knowledge .bm-knowledge-card',
    '.bm-knowledge .bm-knowledge__topics a',
    '.article-template [data-bm-reveal]',
    '.article-template .bm-rich-intro',
    '.article-template .bm-rich-section',
    '.bm-related-articles .bm-related-article',
    '.bm-withdrawal [data-bm-reveal]',
    '.bm-withdrawal .bm-withdrawal__steps > div',
    '.bm-policy-index',
    '.bm-policy-reading-layout .bm-rich-intro',
    '.bm-policy-reading-layout .bm-rich-section',
    '.bm-about-page [data-bm-about-reveal]'
  ].join(',');

  const registered = new WeakSet();
  const observed = new Set();
  let observer = null;
  let failSafeTimer = null;

  document.documentElement.classList.add('bm-motion-ready');

  function delayFor(node, index) {
    if (node.matches('.bm-info-fact,.bm-info-page__related a,.bm-knowledge__topics a,.bm-help-card,.bm-knowledge-card,.bm-related-article,.bm-withdrawal__steps > div,.bm-about-journey__grid article,.bm-about-values__grid article,.bm-about-garage__images figure')) {
      return Math.min(index % 4, 3);
    }
    return 0;
  }

  function register(root = document) {
    const scope = root instanceof Element || root instanceof Document || root instanceof DocumentFragment ? root : document;
    let nodes = [...scope.querySelectorAll(selectors)];
    if (root instanceof Element && root.matches(selectors)) nodes = [root, ...nodes];

    nodes.forEach((node, index) => {
      if (registered.has(node)) return;
      registered.add(node);
      node.classList.add('bm-reveal');
      const delay = delayFor(node, index);
      if (delay) node.classList.add(`bm-reveal--delay-${delay}`);
      observed.add(node);
      if (observer) observer.observe(node);
    });
  }

  function reveal(node) {
    node.classList.add('is-visible');
    observed.delete(node);
    if (observer) observer.unobserve(node);
  }

  function revealAll() {
    observed.forEach(reveal);
    if (failSafeTimer) {
      window.clearTimeout(failSafeTimer);
      failSafeTimer = null;
    }
  }

  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    observed.forEach((node) => observer.observe(node));
    failSafeTimer = window.setTimeout(revealAll, 1800);
  }

  function init() {
    register(document);
    initObserver();
  }

  window.BMMotion = {
    __canonical: true,
    refresh(root = document) {
      register(root);
      if (!observer) initObserver();
    },
    revealAll
  };

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.bm-reveal').forEach((node) => {
      if (!node.classList.contains('is-visible')) reveal(node);
    });
  });

  window.addEventListener('error', revealAll);
  window.addEventListener('unhandledrejection', revealAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
